import React from 'react'
import PropTypes from 'prop-types'

// we need to explicitly pass key since react uses index as default and the problem is that
// after applying filter we can receive different amounts of filterGroups
// TODO if you want to collapse filterGroup after all items are unchecked, pass Math.random() to key
const BOTGuidedNavigation = ({ placeholders: { navigation }, navigation: items }) =>
  React.Children.map(navigation, (component, index) =>
    React.cloneElement(component, { key: items[index].displayName }))

BOTGuidedNavigation.propTypes = {
  navigation: PropTypes.arrayOf(PropTypes.object),
  placeholders: PropTypes.shape({
    navigation: PropTypes.array
  })
}

export default BOTGuidedNavigation
